import $, { css } from 'styled-components';
import { forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';

var f=css`
  gap: 0;
`,m=css`
  gap: var(--spacing-x-small, 4px);
`,w=css`
  gap: var(--spacing-small, 8px);
`,u=css`
  gap: var(--spacing-regular, 16px);
`,y=css`
  gap: var(--spacing-large, 24px);
`,A=css`
  gap: var(--spacing-x-large, 32px);
`,d=css`
  gap: var(--spacing-x-x-large, 48px);
`,R=css`
  gap: var(--spacing-x-x-x-large, 64px);
`,l=$.div`
  display: flex;
  flex-direction: row;
  gap: var(--spacing-large, 24px);

  ${a=>a.$xAlign&&{"justify-content":a.$xAlign}}
  ${a=>a.$yAlign&&{"align-items":a.$yAlign}}

  ${a=>a.$wrap&&"flex-wrap: wrap;"}

  ${a=>a.$fluid&&"flex: 1;"}

  ${a=>a.$spacing==="none"&&f}
  ${a=>a.$spacing==="x-small"&&m}
  ${a=>a.$spacing==="small"&&w}
  ${a=>a.$spacing==="regular"&&u}
  ${a=>a.$spacing==="large"&&y}
  ${a=>a.$spacing==="x-large"&&A}
  ${a=>a.$spacing==="x-x-large"&&d}
  ${a=>a.$spacing==="x-x-x-large"&&R}
`;var n=forwardRef(function({spacing:p="large",wrap:i=!1,fluid:g=!1,xAlign:o,yAlign:e,className:s,children:t,...x},c){return jsx(l,{ref:c,$spacing:p,$wrap:i,$fluid:g,$xAlign:o,$yAlign:e,className:s,...x,children:t})});n.displayName="Row";var H=$(n)``;

export { H as a };
